import memoizeOne from 'memoize-one';
export const getPopupProps = memoizeOne((width, target, onFlip, boundariesElement, offset, placement, rootBoundary, shouldFlip, popupTitle) => ({
  searchThreshold: -1,
  controlShouldRenderValue: true,
  minMenuWidth: width,
  maxMenuWidth: width,
  autoFocus: false,
  target,
  popupTitle,
  popperProps: {
    placement: placement || 'auto',
    strategy: 'fixed',
    modifiers: [{
      name: 'offset',
      options: {
        offset
      }
    }, {
      name: 'handleFlipStyle',
      enabled: true,
      order: 910,
      fn: data => onFlip(data)
    }, {
      name: 'preventOverflow',
      options: {
        rootBoundary: rootBoundary,
        boundary: boundariesElement
      }
    }, {
      name: 'flip',
      enabled: shouldFlip
    }]
  }
}));